import {Deserializable} from "./deserializable.model";

export class JobTypeLocation {

    job_type_location_id: number;
    job_type_location_name: string;
    job_type_location_description: string;
    is_active: string;
    job_type_id: number;



  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): JobTypeLocation {
    Object.assign(this, input);

    return this;
  }


}
